<!--错题本-->
<template>
    <div class="el-WrongQuestion">
        <!-- <h1 class="head_title" style="margin-top:-20px;">
            Python课程设计 错题本
        </h1> -->
        <el-row class="page_content">
            <h1 class="head_title_white">
                <h1 style="float: left;color: #000000;line-height: 40px;margin: 0;">{{courseName}} 错题本</h1>
                <el-button type="primary" @click="backOff">返 回</el-button>
            </h1>
            <div class="bg_"></div>
            <el-row style="padding: 20px;">
                <div style="font-size: 20px;padding-bottom: 20px;">
                    练习方式：
                    <el-button type="primary" :plain="lxfs === '1'?false:true" @click="lxfs = '1'">按作业模块练习</el-button>
                    <el-button type="primary" :plain="lxfs === '1'?true:false" @click="practice_zj();">直接练习</el-button>
                </div>
                <el-table
                  :data="tableData"
                  border
                  style="width: 100%;">
                  <el-table-column
                      prop="homeworkQuestionStem"
                      header-align="center"
                      align="center"
                      label="题目名称">
                      <template slot-scope="scope">
                        <el-row v-html="scope.row.homeworkQuestionStem"></el-row>
                      </template>
                  </el-table-column>
                  <el-table-column
                      prop="paperName"
                      header-align="center"
                      align="center"
                      label="平时作业">
                  </el-table-column>
                  <el-table-column
                      prop="homeworkQuestionTypeName"
                      header-align="center"
                      align="center"
                      label="题型" width="100">
                  </el-table-column>
                  <el-table-column
                      prop="homeworkCount"
                      header-align="center"
                      align="center"
                      label="练习次数" width="100">
                  </el-table-column>
                  <el-table-column
                      prop="title"
                      header-align="center"
                      align="center"
                      label="操作" width="200">
                      <template slot-scope="scope">
                          <el-button type="success" size="small" @click="practice(scope.row)">练 习</el-button>
                          <el-button type="danger" size="small" @click="delPractice(scope.row)">移 除</el-button>
                      </template>
                  </el-table-column>
              </el-table>
              <div class="block">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                  :current-page.sync="currentPage1" :page-size="limit" :hide-on-single-page="true"
                  layout="total, prev, pager, next" :total="total">
                </el-pagination>
              </div>
            </el-row>
        </el-row>
    </div>
</template>
<script>
export default {
  name: "WrongQuestion",
  data() {
    return {
      courseName:"",
      tePlanCourseId:this.$route.query.tePlanCourseId,
      lxfs:'1',
      tableData: [],
      currentPage1: 1,
      total: 0,
      limit: 6,
      page: 1
    };
  },
  created() {
    this.wrongQuestionQuery();
  },
  methods: {
      backOff(){
        this.$router.go(-1);
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.page = val;
        this.wrongQuestionQuery();
      },
      wrongQuestionQuery() { //获取错题列表
        const param = {
          limit: this.limit,
          page: this.page,
          tePlanCourseId:this.tePlanCourseId
        }
        this.$store.dispatch("user/wrongQuestionQuery", param).then((ret) => {
          if (ret.code != 0 && ret.code != '0') {
            this.$message({
              message: ret.msg,
              type: 'warning'
            });
          } else {
            this.courseName = ret.courseName;
            this.tableData = ret.data;
            this.total = ret.count;
          }
        });
      },
      practice(item){  //练习
        this.$router.push({name:'WrongExercise',query:{
          homeworkStudentId:item.homeworkStudentId,
          tePlanCourseId:this.$route.query.tePlanCourseId
          },
        });
      },
      practice_zj(){ //直接练习
        this.$router.push({name:'WrongExercise',query:{tePlanCourseId:this.$route.query.tePlanCourseId}});
      },
      delPractice(item){ //移除练习
        this.$store.dispatch("user/deleteWrongQuestion", {studentWrongQuestionLogId:item.studentWrongQuestionLogId}).then((ret) => {
          if (ret.code != 0 && ret.code != '0') {
            this.$message({
              message: ret.msg,
              type: 'warning'
            });
          } else {
            this.wrongQuestionQuery();
          }
        });
      }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-WrongQuestion{
    .head_title_white{
        text-align: right;
        margin-bottom:0;
        padding: 10px 30px;
    }
    .bg_{
        height: 10px;
        background-color: @mainBg;
        margin: 0 -20px;
    }
    .learning_img{
        width: 280px;height: 220px;border: 1px solid rgb(238, 238, 238);float: left;margin-right: 20px;
    }
    .el-main{
        min-width: 1200px;
    }
    .block {
      text-align: center;
      width: 96%;
      margin-bottom: 20px;
      margin-top: 20px;
    }
    .zyleft{
        float: left;
        line-height: 150px;
        padding: 0 40px 0 25px;
        font-size: 20px;
        color: @primary;
    }
    .zy{
        border: 1px solid rgb(164, 164, 255);width: 650px;height: 150px;border-radius: 10px;margin: 25px auto;padding: 0 20px;
    }
    .odyContainer{
        height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/learningCenter/WrongQuestion.vue